<template>
  <fieldset class="form-group">
    <div class="row">
      <legend class="col-12 col-form-label text-primary pt-0 mb-3">
        <h5>
          Responsable del Sistema de Gestión de la calidad del Organismo de
          Inspección
        </h5>
      </legend>
    </div>

    <div class="row" v-if="!disabled">
      <div class="col-sm-12">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="addResponsable"
          >
            {{ $t("add_responsable") }}
          </button>
        </div>
      </div>
    </div>

    <div v-for="(value, key) in inputs" :key="key">
      <div class="row" v-if="value.type == 'RSGCOI'">
        <div class="col-md-4">
          <div class="form-group">
            <label>{{ $t("full_name") }}</label>
            <app-input
              type="text"
              v-model="value.name"
              placeholder="Ingrese sus nombres y apellidos"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group mb-2 mb-md-0">
            <label>{{ $t("position") }}</label>
            <app-input
              type="select"
              v-model="value.responsable_id"
              :required="true"
              :list="responsibleList"
              :disabled="disabled"
            />
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label>{{ $t("sector") }}</label>
            <app-input
              type="text"
              v-model="value.sector"
              placeholder="Ingrese el sector"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "ResponsableAdd",
  props: {
    inputs: Array,
    disabled: Boolean,
  },
  created() {},
  computed: {
    responsibleList() {
      return this.$store.state.accreditation.responsible
        ? [
            { id: "", value: this.$t("select_option") },
            ...this.$store.state.accreditation.responsible,
          ]
        : [{ id: "", value: this.$t("select_option") }];
    },
  },
  methods: {
    addResponsable() {
      this.inputs.push({
        id: null,
        name: "",
        responsable_id: null,
        sector: "",
        position: null,
        email: null,
        type_responsable_id: 2,
        accreditation_application_id: this.$store.state.accreditation.id,
        type: "RSGCOI",
      });
    },
  },
};
</script>
